import React from "react";
import SkillItem from "../Assets/SkillItem";
import SkillText from "../Texts/SkillText";
import { Skills } from "../../Data/SkillList";

export default () => {
  return (
    <div className="skills" id="skills">
      <div
        className="text-container"
        style={{
          backgroundColor: "transparent",
          color: "white",
          textAlign: "center",
        }}
      >
        <SkillText />
      </div>
      <div className="skills-container">
        {Skills.filter((e) => e.type === "Language")
          .sort((a, b) => b.type - a.type)
          .sort((a, b) => b.percent - a.percent)
          .map((e) => (
            <SkillItem
              imgSrc={e.imgSrc}
              percent={e.percent}
              header={e.header}
              key={e.id}
              class_={e.type}
            />
          ))}
      </div>
      <div className="skills-container">
        {Skills.filter((e) => e.type === "Framework")
          .sort((a, b) => b.type - a.type)
          .sort((a, b) => b.percent - a.percent)
          .map((e) => (
            <SkillItem
              imgSrc={e.imgSrc}
              percent={e.percent}
              header={e.header}
              key={e.id}
              class_={e.type}
            />
          ))}
      </div>
      <div className="skills-container">
        {Skills.filter((e) => e.type === "Hardware")
          .sort((a, b) => b.type - a.type)
          .sort((a, b) => b.percent - a.percent)
          .map((e) => (
            <SkillItem
              imgSrc={e.imgSrc}
              percent={e.percent}
              header={e.header}
              key={e.id}
              class_={e.type}
            />
          ))}
        {Skills.filter((e) => e.type === "Software")
          .sort((a, b) => b.type - a.type)
          .sort((a, b) => b.percent - a.percent)
          .map((e) => (
            <SkillItem
              imgSrc={e.imgSrc}
              percent={e.percent}
              header={e.header}
              key={e.id}
              class_={e.type}
            />
          ))}
      </div>
    </div>
  );
};
